/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import CategorieType from '../types/CategorieType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/categories';

let items = [];

const categories = {
    type: new List(CategorieType),
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            items = data;
            return items;

        });
    },
};

export default categories;



// WEBPACK FOOTER //
// ./data/queries/categories.js